module.exports = __webpack_public_path__ + "media/brands/saab-29cb4ac1.png";